import * as React from 'react';
import { SVGProps } from 'react';
export const WorksIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={26}
    viewBox="0 0 22 26"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M21 0H4a4 4 0 0 0-4 4v21a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2H2a2 2 0 0 1 2-2h17a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Zm-3 12-3.201-2.4a.5.5 0 0 0-.6 0L11 12V2h7v10Z"
    />
  </svg>
);
